export enum PlatformBillingBasisStateEnum {
    DRAFT = 'draft',
    READY = 'ready',
    INVOICED = 'invoiced',
    CANCELLED = 'cancelled',
    ERROR = 'error',
}
